import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { ActivatedRoute, Router ,RouterModule} from "@angular/router";
import { EmiBaseInfoService } from '../services/emi-base-info.service';

@Component({
  selector: 'emi-header-banner',
  templateUrl: './emi-header-banner.component.html',
  styleUrls: ['./emi-header-banner.component.css']
})
export class EmiHeaderBannerComponent implements OnInit {
  
  @Output() clicked = new EventEmitter();
  pageData: any;

  images = [1, 2, 3, 4].map(() => `https://picsum.photos/900/500?random&t=${Math.random()}`);

  constructor(
    private baseInfoService:EmiBaseInfoService,
    private route: ActivatedRoute,
    private router:Router,
  ) {
    baseInfoService.pageDataFetched$.subscribe(
    data => {
      
      this.getPageData();
    });
    baseInfoService.urlFetched$.subscribe(
    url => {
  
      if(url!='#'&&url&&url!=''){
        if(url.charAt(0)=='/'){
           this.router.navigateByUrl(url);
        }else{
          window.location.href=url;
        }
        }else{
          console.log('I am hash');
        }
    });
    
  }


  ngOnInit() {
    this.getPageData();
  }

  getPageData(){
    if(localStorage.getItem(emiGlobals.pageInfo)){
      this.pageData = JSON.parse(localStorage.getItem(emiGlobals.pageInfo));
      console.log('------------ this.pageData  this.pageData ' ,  this.pageData );
    }
  }

  getSliderData(){
    return this.pageData.banner_slider_text;
  }
  click(){
        let url=this.pageData.banner_button_action;
       
        this.baseInfoService.announceExploreButtonClicked(url);
        
     
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/emi-header-banner/emi-header-banner.component.ts